import './App.css';
import { PAGE } from "./config";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import MainLayout from "./components/layout/MainLayout"

//sample
import SamplePage from "./pages/SamplePage";
import SamplePageDetail from "./pages/SamplePage_Detail";
import SamplePageTab from "./pages/SamplePage_Tab";
//auth
import LoginPage from './pages/auth/LoginPage';
import InitPwdPage from './pages/auth/InitPwdPage';
//main
import DashboardPage from './pages/main/DashboardPage';
import NewDashboardPage from './pages/main/NewDashboardPage';
//trans
import TotalPage from './pages/trans/TotalPage';
import HistPage from './pages/trans/HistPage';
import HistPopUpPage from './pages/trans/HistPopUpPage';
//cash
import VaultPage from './pages/cash/VaultPage';
import VaultPopUpPage from './pages/cash/VaultPopUpPage';
import ClosePage from './pages/cash/ClosePage';
import EndOfDayReportPage from './pages/cash/EndOfDayReportPage';
import CloseDailyPopUpPage from './pages/cash/CloseDailyPopUpPage';
import CloseUserPopUpPage from './pages/cash/CloseUserPopUpPage';
//oper
import MachinePage from './pages/oper/MachinePage';
import MachineModifyPage from './pages/oper/MachineModify'
import UserPage from './pages/oper/UserPage';
import TillPage from './pages/oper/TillPage';
import StatusPage from './pages/main/StatusPage';
import StatusPopUpPage from './pages/oper/StatusPopUpPage';
//system
import ProgramPage from './pages/system/ProgramPage';
import FileUploadPopUpPage from './pages/system/FileUploadPopUpPage';
import RemotePage from './pages/system/RemotePage';
import LogPopUpPage from './pages/system/LogPopUpPage';
import MenuPage from './pages/system/MenuPage';
import GroupPage from './pages/oper/GroupPage';
import MenuAuthPopUpPage from './pages/system/MenuAuthPopUpPage';
import CodePage from './pages/system/CodePage';
import SystemMachinePage from './pages/system/SystemMachinePage';
import StorePage from './pages/system/StorePage';
import BranchPage from './pages/system/BranchPage';
import BranchGroupPage from './pages/system/BranchGroupPage';
import PmsLogPage from './pages/system/PmsLogPage';
//auth
import AuthenticatedRoute from './pages/auth/AuthenticatedRoute';
import NotFoundPage from './pages/auth/NotFoundPage';

import { Helmet } from 'react-helmet';

function App() {
  return (
    <>
    <Helmet>
      <title>ezCAMS</title>
    </Helmet>
    <Router>
        <Switch>
          {/* 공통업무-로그인 */}
          <Route path="/" exact component={LoginPage} />
          <Route path={PAGE.AUTH.LOGIN} exact component={LoginPage} />
          <Route path={PAGE.AUTH.INITPWD} exact component={InitPwdPage} />
          <Route path={PAGE.AUTH.LOGOUT} exact component={LoginPage} />

          {/* 일일마감내역상세조회(팝업) */}
          {/* <AuthenticatedRoute path={PAGE.CASH.CLOSE_DAILY_POPUP} exact component={CloseDailyPopUpPage} />  
          <AuthenticatedRoute path={PAGE.CASH.CLOSE_DAILY_POPUP+"/:branch"+"/:machId"+"/:date"} exact component={CloseDailyPopUpPage} /> */}

          {/* 사용자마감내역상세조회(팝업) */}
          {/* <AuthenticatedRoute path={PAGE.CASH.CLOSE_USER_POPUP} exact component={CloseUserPopUpPage} />  
			    <AuthenticatedRoute path={PAGE.CASH.CLOSE_USER_POPUP+"/:userId"+"/:date"} exact component={CloseUserPopUpPage} /> */}

          {/* 메뉴권한관리(팝업) */}
			    {/* <AuthenticatedRoute path={PAGE.SYSTEM.MENUAUTH_POPUP+"/:grpCd"} element={<grpCd/>} exact component={MenuAuthPopUpPage} />  */}

          {/* 저널조회(팝업) */}
          {/* <AuthenticatedRoute path={PAGE.TRANS.HIST_POPUP+"/:tid"} exact component={HistPopUpPage} />   */}

          {/* 비밀번호변경(팝업) */}
          {/* <AuthenticatedRoute path={PAGE.OPER.USERPWD_POPUP} exact component={UserPwdPage} />  */}

          {/* 시재거래이력조회(팝업) */}
          {/* <AuthenticatedRoute path={PAGE.CASH.VAULT_POPUP} exact component={VaultPopUpPage} />   */}

          {/* 기기상태(장애내역)(팝업) */}
          {/* <AuthenticatedRoute path={PAGE.OPER.STATUS_POPUP+"/:machId"} exact component={StatusPopUpPage} />  */}

          <AuthenticatedRoute path={PAGE.SYSTEM.FILEUPLOAD_POPUP} exact component={FileUploadPopUpPage} /> {/* 파일업로드(팝업) */}
          <AuthenticatedRoute path={PAGE.SYSTEM.LOG_POPUP} exact component={LogPopUpPage} /> {/* 로그(팝업) */}          
          
          <MainLayout>
            <Switch>
              {/* sample */}
              {/* <AuthenticatedRoute path="/sample" exact component={SamplePage} />
              <AuthenticatedRoute path="/sample_detail" exact component={SamplePageDetail} />
              <AuthenticatedRoute path="/sample_tab" exact component={SamplePageTab} /> */}
              
              {/* main - 공통업무 */}
              <AuthenticatedRoute path={PAGE.MAIN.DASHBOARD} exact component={NewDashboardPage} />  {/* 공통업무-메인(대시보드) */}
              <AuthenticatedRoute path={PAGE.MAIN.STATUS} exact component={StatusPage} /> {/* 기기상태 */}

              {/* trans - 거래정보 */}
              <AuthenticatedRoute path={PAGE.TRANS.TOTAL} exact component={TotalPage} /> {/* 거래집계,거래집계상세 */}
              <AuthenticatedRoute path={PAGE.TRANS.HIST} exact component={HistPage} />  {/* 거래내역 */}

              {/* cash - 자금정보 */}
              <AuthenticatedRoute path={PAGE.CASH.VAULT} exact component={VaultPage} /> {/* 기기시재현황 */}
              <AuthenticatedRoute path={PAGE.CASH.CLOSE} exact component={ClosePage} />  {/* 일일마감내역,사용자마감내역 */}
              <AuthenticatedRoute path={PAGE.CASH.END_OF_DAY_REPORT} exact component={EndOfDayReportPage} />  {/* 일일마감내역,사용자마감내역 */}
              
              {/* oper - 기기운영관리 */}
              <AuthenticatedRoute path={PAGE.OPER.MACHINE} exact component={MachinePage} /> {/* 장비관리 */}
              <AuthenticatedRoute path={PAGE.OPER.USER} exact component={UserPage} /> {/* 사용자관리 */}
              <AuthenticatedRoute path={PAGE.OPER.TILL} exact component={TillPage} /> {/* 준비금설정 */}
              <AuthenticatedRoute path={PAGE.OPER.GROUP} exact component={GroupPage} /> {/* 그룹관리 */}

              {/* system - 시스템관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.PROGRAM} exact component={ProgramPage} /> {/* 프로그램관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.REMOTE} exact component={RemotePage} /> {/* 원격제어관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.MENU} exact component={MenuPage} /> {/* 메뉴관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.CODE} exact component={CodePage} /> {/* 공통코드관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.MACHINE} exact component={SystemMachinePage} /> {/* 기종관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.STORE} exact component={StorePage} /> {/* 브랜드관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.BRANCH} exact component={BranchPage} /> {/* 브랜드관리 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.PMS_LOG} exact component={PmsLogPage} /> {/* PMS수신전문 조회 */}
              <AuthenticatedRoute path={PAGE.SYSTEM.BRANCH_GROUP} exact component={BranchGroupPage} /> {/* 지점그룹관리 */}
              <Route exact path='*' component={NotFoundPage} /> {/* 404 Not Found */}
            </Switch>
          </MainLayout>
        </Switch>
    </Router>
    </>
  );
}

export default App;
